import { useEffect, useState } from "react"
import { type AppResolvedRoute, resolveAppRoute } from "./routes"

function getCurrentPathname(): string {
  if (typeof window === "undefined") return "/"
  return window.location.pathname
}

export type NavigateOptions = {
  replace?: boolean
}

export type AppRouter = AppResolvedRoute & {
  navigate: (pathname: string, options?: NavigateOptions) => void
}

export function useAppRouter(): AppRouter {
  const [pathname, setPathname] = useState(getCurrentPathname)

  useEffect(() => {
    if (typeof window === "undefined") return
    const handlePopState = () => setPathname(getCurrentPathname())
    window.addEventListener("popstate", handlePopState)
    return () => window.removeEventListener("popstate", handlePopState)
  }, [])

  const resolvedRoute = resolveAppRoute(pathname)

  const navigate = (nextPathname: string, options?: NavigateOptions) => {
    if (typeof window === "undefined") return
    const next = resolveAppRoute(nextPathname)
    if (next.pathname === pathname) return
    if (options?.replace) {
      window.history.replaceState({}, "", next.pathname)
    } else {
      window.history.pushState({}, "", next.pathname)
    }
    // Notify all useAppRouter instances — pushState doesn't fire popstate.
    window.dispatchEvent(new PopStateEvent("popstate"))
  }

  return { ...resolvedRoute, navigate }
}
